module.exports = __webpack_public_path__ + "img/favison-couleur-rvb-ubiflow-2026.d4969cc2.svg";